import { __assign, __makeTemplateObject, __rest } from "tslib";
import { css, jsx } from '@emotion/react';
import { useTheme } from './theme/Providers';
import { generateCardStyles } from './utils/helpers';
var element = {
  div: 'div'
};

var getRounded = function getRounded(rounded) {
  switch (rounded) {
    case 'xs':
      return '1rem';

    case 'md':
      return '2rem';

    case 'none':
      return '0rem';
  }
};

export var Card = function Card(_a) {
  var id = _a.id,
      variant = _a.variant,
      bgColor = _a.bgColor,
      _b = _a.rounded,
      rounded = _b === void 0 ? 'xs' : _b,
      children = _a.children,
      component = _a.component,
      _c = _a.tag,
      tag = _c === void 0 ? 'div' : _c,
      _d = _a.shadow,
      shadow = _d === void 0 ? true : _d,
      other = __rest(_a, ["id", "variant", "bgColor", "rounded", "children", "component", "tag", "shadow"]);

  var theme = useTheme();
  var Component = component || element[tag];
  var mainContainerStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    border-radius:", ";\n    width: 100%;\n    box-sizing: border-box;\n    box-shadow: ", ";\n    ", "\n  "], ["\n    background: ", ";\n    border-radius:", ";\n    width: 100%;\n    box-sizing: border-box;\n    box-shadow: ", ";\n    ", "\n  "])), bgColor ? bgColor : theme.colors.scales.gray[12], getRounded(rounded), shadow ? '0 0 0.25rem rgba(2, 18, 21, 0.2)' : '', generateCardStyles(theme, variant));
  return jsx(Component, __assign({}, other, {
    css: mainContainerStyle,
    id: id ? id : ''
  }), children);
};
var templateObject_1;